import { render, staticRenderFns } from "./InsuranceCompanyPlanModal.vue?vue&type=template&id=face763a&scoped=true&"
import script from "./InsuranceCompanyPlanModal.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyPlanModal.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCompanyPlanModal.vue?vue&type=style&index=0&id=face763a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "face763a",
  null
  
)

export default component.exports